import React, { ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

// TODO this component is error, fix it later
export interface FieldLabelProps {
  wrapperAs?: React.ElementType
  labelRightElement?: React.ReactNode
  wrapperProps?: Record<string, unknown>
  label?: React.ReactNode
  required?: boolean
  labelClassName?: string
}

function Label({
  label,
  required,
  labelClassName,
}: Omit<FieldLabelProps, 'labelRightElement' | 'wrapperAs' | 'wrapperProps'>): ReactNode | null {
  if (!label && !required) {
    return null
  }

  return (
    <span className={twMerge('flex', labelClassName)}>
      {label} {required && <i className="text-danger">*</i>}
    </span>
  )
}

export function FieldLabel({
  wrapperAs: WrapperAs = 'div',
  wrapperProps = { className: 'flex justify-between gap-2' },
  label,
  required,
  labelClassName,
  labelRightElement,
}: FieldLabelProps): ReactNode | null {
  if (!label && !required && !labelRightElement) {
    return null
  }

  return (
    <WrapperAs {...wrapperProps}>
      <Label label={label} required={required} labelClassName={labelClassName} />
      {labelRightElement}
    </WrapperAs>
  )
}
